"use strict";

import angular from "angular";
var APP_REGEXP = /apps\/([a-zA-Z-]*)\/.*/;
var MODULE_REGEXP = /modules\/([a-zA-Z-]*)\/.*/;
var appMap = {
  "dette": "tael",
  "dette-garantie": "tael.app.dette-garantie",
  "intra": "intra",
  "observatoire": "tael.app.observatoire",
  "placement": "tael.app.placement",
  "pret": "tael.app.pret",
  "pret-intra": "tael.app.pret-intra",
  "credit-bail": "tael.app.credit-bail",
  "aide-subvention": "tael.app.aide-subvention",
  "of": "tael.app.of"
};
var moduleMap = {
  "common": "tael.module.common",
  "dette": "tael.module.dette",
  "gestion-compte": "tael.module.gestion-compte.main",
  "observatoire": "tael.module.observatoire",
  "placement": "tael.module.placement",
  "pret": "tael.module.pret",
  "pret-intra": "tael.module.pret-intra",
  "credit-bail": "tael.module.credit-bail",
  "aide-subvention": "tael.module.aide-subvention",
  "of": "tael.module.of",
  "interfacage": "tael.module.interfacage",
  "reporting": "tael.module.reporting",
  "reporting-components": "tael.module.reporting.components"
};

/**
 * Cheap trick for retrocompatibility, retrieving the angular module from the current fileName.
 * Used to stay in good ol'way reversed dependency approach.
 *
 * @param filePath The file path to get associated module of.
 * @return The associated angular module to use for this file.
 */
export default function getNgModule(path) {
  var filePath = path.replace(/\\/g, "/"); // fix for windows "\"
  // "src/apps/intra/intra-app.js"

  var ngModule = null;
  var matcher = APP_REGEXP.exec(filePath);
  if (matcher != null) {
    var appName = matcher[1];
    ngModule = appMap[appName];
  } else {
    matcher = MODULE_REGEXP.exec(filePath);
    if (matcher != null) {
      var moduleName = matcher[1];
      ngModule = moduleMap[moduleName];
    }
  }

  // console.log('getNgModule ->', filePath, ngModule);

  if (ngModule != null) {
    return angular.module(ngModule);
  } else {
    throw "Cannot find module for file ".concat(filePath, ". If it is a new module, add it in getNgModule.js");
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/misc/getNgModule.js
// module id = 0
// module chunks = 13